/**
 * FlahaSOIL v2 — application root.
 *
 * Owns the provider stack, real session-restoration gate, and non-interactive
 * workspace atmosphere, then delegates route definition to `routes/AppRoutes`.
 */
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "./auth";
import { AmbientBackdrop } from "./layouts/components/AmbientBackdrop";
import { AppBootGate } from "./layouts/components/AppBootGate";
import { DocumentMeta } from "./layouts/components/DocumentMeta";
import { PageHeaderProvider } from "./layouts/PageHeaderContext";
import { AppRoutes } from "./routes/AppRoutes";
import { flahaSoilTheme } from "./theme/flahaSoilTheme";

// AuthProvider sits outside the router (navigate-free). PageHeaderProvider +
// DocumentMeta wrap all routes so auth and app shells share title/robots policy.
export default function App() {
	return (
		<ThemeProvider theme={flahaSoilTheme}>
			<CssBaseline />
			<Box
				sx={(theme) => ({
					position: "relative",
					isolation: "isolate",
					minHeight: "100vh",
					backgroundColor: theme.palette.workspace.background,
				})}
			>
				<AmbientBackdrop />
				<AuthProvider>
					<AppBootGate>
						<Box sx={{ position: "relative", zIndex: 1, minHeight: "100vh" }}>
							<BrowserRouter>
								<PageHeaderProvider>
									<DocumentMeta />
									<AppRoutes />
								</PageHeaderProvider>
							</BrowserRouter>
						</Box>
					</AppBootGate>
				</AuthProvider>
			</Box>
		</ThemeProvider>
	);
}
